Vendd.Scripts.load(function () {

	Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-version-selector-sku-grid', function (envelope) {

		var $context = envelope.message.data.context,
			$controls = $('.x-product-details-version-selector.sku-grid', $context);

		if ($controls.length < 1)
			return;

		$.each($controls, function (i, control) {
			var $control = $(control);
			var $productGroups = $('.x-product-variant-group', $control);
			var $productBoxes = $('.x-product-variant-box', $control);
			var $totalPriceContainer = $('.js-total-price', $control);
			var $totalPriceValue = $('.js-total-price-value', $totalPriceContainer);
			var $totalQuantityContainer = $('.js-total-quantity', $control);
			var $totalQuantityValue = $('.js-total-quantity-value', $totalQuantityContainer);
			var $addToCartButton = $('.js-add-to-cart-multiple', $control);

			// Properties

			control.loading = function (loading) {
				if (loading === undefined) {
					return $control.hasClass('x-loading');
				}
				else {
					$control.toggleClass('x-loading', loading);
				}
			};

			control.totalPrice = function () {
				var value;

				$productGroups.each(function (i, productGroup) {
					var groupValue = productGroup.subtotalPrice();
					if (groupValue !== undefined) {
						value = (value || 0) + groupValue;
					}
				});

				return value;
			};

			control.totalQuantity = function () {
				var value;

				$productGroups.each(function (i, productGroup) {
					var groupValue = productGroup.subtotalQuantity();
					if (groupValue !== undefined) {
						value = (value || 0) + groupValue;
					}
				});

				return value;
			};

			// Methods

			control.addToCart = function () {
				if (control.loading()) {
					return false;
				}

				var data = [];

				$productBoxes.each(function (i, productBox) {
					if (productBox.isEnabled() && productBox.selectedQuantity()) {
						var $productBox = $(productBox);
						data.push({
							id: $productBox.data('productid'),
							skuId: $productBox.data('variantid'),
							path: $productBox.data('path'),
							qty: productBox.selectedQuantity()
						});
					}
				});

				if (!data || !data.length) {
					return false;
				}

				console.log(JSON.stringify(data));

				control.loading(true);

				Vendd.MessageBus.publishAsync(control, new Vendd.Cart.Messages.MultipleAdd(data));
				//Vendd.MessageBus.publishAsync(productBox, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));

				return true;
			};

			control.updateTotalPrice = function () {
				var value = control.totalPrice();
				var valueLiteral = NumberFormatter.formatPrice(value);
				$totalPriceValue.text(valueLiteral);
				$totalPriceContainer.toggleClass('total-price-visible', 0 < valueLiteral.length);
			};

			control.updateTotalQuantity = function () {
				var value = control.totalQuantity();
				var valueLiteral = NumberFormatter.formatInt(value);
				$totalQuantityValue.text(valueLiteral);
				$totalQuantityContainer.toggleClass('total-quantity-visible', 0 < valueLiteral.length);
			};

			control.updateButtonState = function () {
				$addToCartButton.pdControlDisabled(control.totalPrice() === undefined || control.totalQuantity() === 0 || control.loading());
			};

			control.init = function () {
				$productGroups.each(function (j, productGroup) {
					var $productGroup = $(productGroup);
					var $productBoxes = $('.x-product-variant-box', $productGroup);
					var $subtotalPriceContainer = $('.js-subtotal-price', $productGroup);
					var $subtotalPriceValue = $('.js-subtotal-price-value', $subtotalPriceContainer);
					var $subtotalQuantityContainer = $('.js-subtotal-quantity', $productGroup);
					var $subtotalQuantityValue = $('.js-subtotal-quantity-value', $subtotalQuantityContainer);

					productGroup.subtotalPrice = function () {
						var value;

						$productBoxes.each(function (i, productBox) {
							var itemValue = productBox.totalPrice();
							if (itemValue !== undefined) {
								value = (value || 0) + itemValue;
							}
						});

						return value;
					};

					productGroup.subtotalQuantity = function () {
						var value;

						$productBoxes.each(function (i, productBox) {
							var itemValue = productBox.selectedQuantity();
							if (itemValue !== undefined) {
								value = (value || 0) + itemValue;
							}
						});

						return value;
					};

					productGroup.init = function () {

						$productBoxes.each(function (k, productBox) {
							var $productBox = $(productBox);
							var $quantitySelector = $('.js-quantity-selector', $productBox).first();

							var unitPriceLiteral = $productBox.data('unit-price');
							var unitPriceValue = NumberFormatter.parsePrice(unitPriceLiteral);

							// Properties

							productBox.isEnabled = function () {
								return (unitPriceValue !== undefined);
							};

							productBox.selectedQuantity = function () {
								return productBox.isEnabled() ? $quantitySelector.get(0).quantity() : undefined;
							};

							productBox.unitPrice = function () {
								return unitPriceValue;  // NOTE: Might be undefined
							};

							productBox.totalPrice = function () {
								return productBox.unitPrice() * productBox.selectedQuantity(); // NOTE: Might be undefined
							};

							// Methods

							productBox.init = function () {
								$quantitySelector.pdQuantitySelector({
									min: 0, // NOTE: Ignore 'min-quantity'; should always be zero (0).
									max: NumberFormatter.parse($productBox.data('max-quantity')),
									step: NumberFormatter.parse($productBox.data('quanta')),
									value: 0
								});

								productBox.updateQuantitySelector();
							};

							productBox.updateQuantitySelector = function () {
								$quantitySelector.pdControlDisabled(productBox.unitPrice() === undefined);
							};

							// Events

							$quantitySelector.on('product:change', function (e) {
								e.preventDefault();
							});

							// Initialization

							productBox.init();
						});

						productGroup.updateSubtotalPrice();
						productGroup.updateSubtotalQuantity();
					};

					productGroup.updateSubtotalPrice = function () {
						var value = productGroup.subtotalPrice();
						var valueLiteral = NumberFormatter.formatPrice(value);
						$subtotalPriceValue.text(valueLiteral);
						$subtotalPriceContainer.toggleClass('subtotal-price-visible', 0 < valueLiteral.length);
					};

					productGroup.updateSubtotalQuantity = function () {
						var value = productGroup.subtotalQuantity();
						var valueLiteral = NumberFormatter.formatInt(value);
						$subtotalQuantityValue.text(valueLiteral);
						$subtotalQuantityContainer.toggleClass('subtotal-quantity-visible', 0 < valueLiteral.length);
					};

					// Events

					$productBoxes.on('product:change', function (e) {
						e.preventDefault();

						productGroup.updateSubtotalPrice();
						productGroup.updateSubtotalQuantity();
					});

					// Initialization

					productGroup.init();
				});

				control.updateTotalPrice();
				control.updateTotalQuantity();
				control.updateButtonState();
			};

			// Events

			$productGroups.on('product:change', function (e) {
				e.preventDefault();

				control.updateTotalPrice();
				control.updateTotalQuantity();
				control.updateButtonState();
			});

			$addToCartButton.on('click', function (e) {
				e.preventDefault();

				if ($addToCartButton.pdControlDisabled()) {
					return;
				}
				if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening')) {
					return;
				}

				control.addToCart();
				control.updateButtonState();
			});

			Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAddSuccess, control, function (envelope) {
				control.loading(false);
				control.updateButtonState();
			});

			Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, control, function (envelope) {
				control.loading(false);
				control.updateButtonState();
			});

			// Initialization

			control.init();
		});
	});
});
